import React from "react"
import { NavLink } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { List, ListItem, Typography, styled } from "@mui/material"

import { ReactComponent as IconClaims } from "assets/icons/claims.svg"
import { ReactComponent as IconFaq } from "assets/icons/faq.svg"
import { ReactComponent as IconProfile } from "assets/icons/profile.svg"
import { useAppSelector } from "redux/hooks"
import { selectSettingsById } from "redux/features/settings/settingsSlice"
import { SettingsType } from "types"

const ClientMenuComponent = () => {
  const { t } = useTranslation()

  const settings = useAppSelector(
    (state) => selectSettingsById(state, 0) as SettingsType,
  )

  const getIconComponentByName = (name: string) => {
    switch (name) {
      case "claims":
        return <IconClaims />
      case "profile":
        return <IconProfile />
      default:
        return <IconFaq />
    }
  }

  const menuList = (settings?.navigation || []).map((item, index) => (
    <ListItem key={index}>
      <MenuLink to={item.path}>
        <>{getIconComponentByName(item.name)}</>
        <MenuLinkTitle>{t(`menu.${item.name}`)}</MenuLinkTitle>
      </MenuLink>
    </ListItem>
  ))

  return <List data-testid="client-menu-list">{menuList}</List>
}

export default ClientMenuComponent

const MenuLink = styled(NavLink)(({ theme }) => ({
  color: theme.palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  fontSize: "0.875rem",
  opacity: "0.5",
  padding: "9px",
  width: "100%",
  "&.active": {
    background: "rgba(255, 255, 255, 0.1)",
    borderRadius: "6px",
    opacity: "1",
  },
}))

const MenuLinkTitle = styled(Typography)(() => ({
  fontSize: "0.875rem",
  fontWeight: "500",
  lineHeight: "1.57",
  marginLeft: "10px",
}))
